
import { Option } from '@/models/option';
import { OptionGroup } from '@/models/option-group';
import { PathSegment } from '@/models/path-segment';
import he from 'he';
import { defineComponent, PropType } from 'vue';
import { useStore } from 'vuex';

export default defineComponent({
  name: 'SummaryChosenSelectionCard',
  props: {
    chosenAdditionalOptions: {
      type: [] as PropType<Option[]>,
      required: false,
      default: null
    },
    chosenSegmentsTitles: {
      type: [] as PropType<PathSegment[]>,
      required: false,
      default: null
    }
  },
  setup() {
    const store = useStore();

    /**
     * Decodes HTML entities like &#40;Echt jetzt!&#41;
     * @param input
     */
    function decodeHtmlEntities(input: string): string {
      return he.decode(input);
    }

    /**
     * Returns the group title associated with the given option or an empty
     * string if none was found.
     * @param option The option to get the group title for.
     */
    function getGroupTitleForOption(option: Option): string {
      return decodeHtmlEntities(store.state.optionGroups.find((og: OptionGroup) => og.options.includes(
          option.id))?.title ?? '');
    }

    return {
      decodeHtmlEntities,
      getGroupTitleForOption
    };
  }
});
